/**
 * Un lien « Panier » dans un menu pointe vers /cart et quitte la page.
 * On intercepte le clic pour ouvrir le drawer à la place, quand il existe.
 *
 * Fichier séparé et chargé avec le drawer lui-même : il doit fonctionner
 * même quand le panier est vide.
 */
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href*="/cart"]');
  if (!link) return;

  const root = window.Shopify?.routes?.root ?? '/';
  const cartPath = root.endsWith('/') ? `${root}cart` : `${root}/cart`;
  const path = new URL(link.href, window.location.origin).pathname;

  // On ne touche ni au checkout ni aux routes internes (/cart/add, /cart/change…).
  if (path !== cartPath && path !== `${cartPath}/`) return;

  const drawer = document.getElementById('cart-drawer');
  if (!drawer || typeof drawer.toggle !== 'function') return;

  event.preventDefault();
  drawer.toggle();
});
